import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArYodaRulesAddedApprovalAndPublishNotifyFollowersProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArYodaRulesAddedApprovalAndPublishNotifyFollowers: TemplateDefinition<ArYodaRulesAddedApprovalAndPublishNotifyFollowersProps> =
  {
    renderParams: (props: ArYodaRulesAddedApprovalAndPublishNotifyFollowersProps) => ({
      messageKey: 'notificationsDomain.templates.arYodaRulesAddedApprovalAndPublishNotifyFollowers',
      values: { ruleName: props?.request?.name },
    }),
  }
